import { TypeOfArticle, TypeOfDivision } from "@coworker/types/lib/testbuy";

// Array representing the options for amounts of articles to test buy
export const AMOUNTS: number[] = [5, 10, 15, 20];
export const DEFAULT_AMOUNT = AMOUNTS[1] ?? 10;
export const WHOLE_STORE_HFB = "whole=whole";
// List of options for type of articles list to test buy
export const TYPES_OF_ARTICLES: TypeOfArticle[] = [
  { type: "RANDOM", transKey: "randomString" },
  { type: "ACESANDKING", transKey: "acesAndKingString" },
  { type: "CUSTOM", transKey: "customPeriodString" },
];
export const allDivisions: TypeOfDivision[] = [
  {
    divisionShortName: "SR",
    translationString: "divsionsShowRoomString",
  },
  {
    divisionShortName: "MH",
    translationString: "divisionsMarketHall",
  },
  {
    divisionShortName: "WH",
    translationString: "divisionsWareHouse",
  },
  {
    divisionShortName: "OT",
    translationString: "divisionOthers",
  },
  {
    divisionShortName: "SF",
    translationString: "divisionSelfServe",
  },
  {
    divisionShortName: "whole-store",
    translationString: "wholeStoreString",
  },
];

export const ARTICLE_HASH = {
  RANDOM: TYPES_OF_ARTICLES[0],
  ACESANDKING: TYPES_OF_ARTICLES[1],
  CUSTOM: TYPES_OF_ARTICLES[2],
};

export const COMPLETED_STATUS: string = "COMPLETED";
